module.exports = __webpack_public_path__ + "img/logo-on-white.7bf05b5c.png";